import { Route, Routes } from "react-router-dom";
import ProcurementModule from ".";

const ProcurementRoute = () => {
  return (
    <Routes>
      <Route path="/*" element={<ProcurementModule />} />
    </Routes>
  );
};

export default ProcurementRoute;
